<div class="d-flex etablissement-container min-vh-100">
  <app-sidebar></app-sidebar>
  <div class="wrapper pb-px-24">
    <app-etablissement-header></app-etablissement-header>

    <router-outlet></router-outlet>
  </div>
</div>
